import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxDialogComponent } from './phx-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  imports: [CommonModule, OverlayModule, A11yModule],
  declarations: [PhxDialogComponent],
  exports: [PhxDialogComponent],
})
export class PhxDialogModule {}
